var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHorizontalSigningIcon = function SvgHorizontalSigningIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 223.8 172.7",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.7,159.9c0,4.4-3.6,8-8,8H13.4c-4.4,0-8-3.6-8-8V14.2c0-4.4,3.6-8,8-8h37.3c4.4,0,8,3.6,8,8v145.7s0,0,0,0ZM21.4,22.2v129.7s21.3,0,21.3,0V22.2s-21.3,0-21.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.7,159.9c0,4.4-3.6,8-8,8h-37.3c-4.4,0-8-3.6-8-8V14.2c0-4.4,3.6-8,8-8h37.3c4.4,0,8,3.6,8,8v145.7s0,0,0,0ZM101.4,22.2v129.7s21.3,0,21.3,0V22.2s-21.3,0-21.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217.7,159.9c0,4.4-3.6,8-8,8h-37.3c-4.4,0-8-3.6-8-8V14.2c0-4.4,3.6-8,8-8h37.3c4.4,0,8,3.6,8,8v145.7s0,0,0,0ZM180.3,22.2v129.7s21.3,0,21.3,0V22.2s-21.3,0-21.3,0Z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHorizontalSigningIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "HorizontalSigning-icon.5bbb944070edc43a885649f912efd3a9.svg";